import {
  cashPickupUrl,
  idUrl,
  workingHoursUrl,
  Recipient_Cash_Pickup_Details
} from '../../utils/constants';

export const PAYOUT_TITLE = {
  LOCAL: 'Recipient bank details',
  PROXY: 'Recipient receiving details',
  CARD: 'Recipient card details',
  CASH_PAYOUT: Recipient_Cash_Pickup_Details,
  WALLET: 'Recipient wallet details'
};

export const BENE_FIELDS = {
  personal_details: [
    'remitter_beneficiary_relationship',
    'beneficiary_name',
    'beneficiary_contact_country_code',
    'beneficiary_contact_number',
    'beneficiary_email',
    'beneficiary_identification_type',
    'beneficiary_identification_value',
    'beneficiary_alias',
    'beneficiary_address',
    'beneficiary_city',
    'beneficiary_state',
    'beneficiary_postcode',
    'beneficiary_country_code',
    'beneficiary_first_name'
  ],
  payout_details: [
    'beneficiary_bank_name',
    'routing_code_value_1',
    'routing_code_value_2',
    'beneficiary_bank_code',
    'beneficiary_account_number',
    'beneficiary_bank_account_type',
    'beneficiary_card_expiry_date',
    'beneficiary_card_issuer_name',
    'card_token_number',
    'routing_code_type_1',
    'routing_code_type_2',
    'proxy_type',
    'proxy_value',
    'card_number',
    'card_token',
    'routing_config_type'
  ]
};

export const SELF_POPULATING_FIELDS = {
  beneficiary_name: 'remitter_individual_full_name',
  beneficiary_contact_country_code: 'remitter_individual_mobile_country_code',
  beneficiary_contact_number: 'remitter_individual_mobile_number',
  beneficiary_email: 'email',
  beneficiary_country_code: 'country_code'
};

// eslint-disable-next-line max-len
export const cashPickupNote = `<span> Please note: Your recipient can collect the cash at any of our available <a href=${cashPickupUrl} target="_blank">cash pick-up locations</a> during <a href=${workingHoursUrl} target="_blank">working hours</a> when it’s ready for pick-up.</span><span> They will need to bring along their <a href=${idUrl} target="_blank">valid ID</a> and cash pick-up reference ID, which will be shared via email once you fund your transfer. It will also be visible in your Transaction history.</span>`;

export const beneficiaryFieldsForINvalidation = (isRequired = false) => {
  const validationObjectForIn = {
    first_name: {
      render: {
        field: 'text',
        label: 'First name',
        disabled: false,
        visibility: 'VISIBLE',
        value_field_name: 'first_name',
        displayWarning: true,
        tooltip: null,
        sequence: 1
      },
      validation: {
        type: 'string',
        max_length: 255,
        pattern: '^[a-zA-Z ]*$',
        required: true,
        error_message: `Special characters & numbers not allowed`
      }
    },
    middle_name: {
      render: {
        field: 'text',
        label: 'Middle name (optional)',
        disabled: false,
        visibility: 'VISIBLE',
        value_field_name: 'middle_name',
        displayWarning: true,
        tooltip: null,
        sequence: 2
      },
      validation: {
        type: 'string',
        max_length: 255,
        pattern: '^[a-zA-Z ]*$',
        required: false,
        error_message: `Special characters & numbers not allowed`
      }
    },
    last_name: {
      render: {
        field: 'text',
        label: 'Last name',
        disabled: false,
        visibility: 'VISIBLE',
        value_field_name: 'last_name',
        displayWarning: true,
        tooltip: null,
        sequence: 3
      },
      validation: {
        type: 'string',
        max_length: 255,
        pattern: '^[a-zA-Z ]*$',
        required: !isRequired,
        error_message: `Special characters & numbers not allowed`
      }
    }
  };
  return validationObjectForIn;
};

export const BENEFICIARY_FULL_NAME_WARNING_MESSAGE = {
  nameUnderTwoChars: (field) => `Recipient’s ${field.toLowerCase()} has less than 2 characters. 
                    We may run extra checks to ensure it matches their ID after your transaction is created.`
};

export const PAYTM_UPI_ID_ERROR_MESSAGE =
  'UPI transfers to Paytm are currently not supported. Please enter a different UPI ID.';

export const BankAccountTypeEnum = {
  SELF: 'SELF',
  JOINT: 'JOINT'
};
export const SelectBankAccountTypeHeading = 'How would you like to fund this transaction?';
export const accountTypes = [
  {
    label: 'Own bank account',
    subtext: 'The account should be registered under your name',
    value: BankAccountTypeEnum.SELF
  },
  {
    label: 'Joint bank account',
    subtext: 'Your name should be registered as a joint account holder',
    value: BankAccountTypeEnum.JOINT
  }
];
